<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table hide-upsert :config="config" title="Shipment" upsert-max-width="650px" @update="editShipment"
          @filters="updateFilters">

          <template slot='headerActions'>

            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">

                <v-btn v-on="on" v-if="$can('read', 'shipment')" color="secondary" :loading="loadingExport"
                  :disabled="!exportEnabled" @click="exportExcel()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>

              </template>
              <span>Export Excel</span>
            </v-tooltip>

            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <div v-on="on" class="d-inline-block">
                  <v-btn data-test="newShipment" v-if="$can('upsert', 'shipment')" color="secondary"
                    @click="newShipment()">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>

              </template>
              <span v-if="canCreate">New Shipment</span>
              <span v-if="!canCreate">You can create a new shipment only on Monday, Tuesday and Wednesday</span>
            </v-tooltip>
          </template>

        </core-table>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import config from './config_index.js'
import { download } from '@/api/base_entity.js'

export default {
  data() {
    return {
      config,
      loadingExport: false,
      exportEnabled: false,
      filters: null
    }
  },
  mounted() {
  },
  computed: {
    isEMN() {
      return this.$store.getters.user.role == 'EMN Logistic'
    },
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
    isSite() {
      return this.$store.getters.user.role == 'Site'
    },
    isLab() {
      return this.$store.getters.user.role == 'Lab'
    },
    canCreate() {
      const date = new Date();
      const day = date.getDay();
      // Per i Site le spedizioni si possono fare solo il Lunedì, il Martedì e il Mercoledì
      return [1,2,3].includes(day) || this.isAdmin || this.isEMN || this.isLab
    }
  },
  methods: {
    newShipment() {
      this.$router.push(`/shipment`)
    },
    editShipment(shipment) {
      this.$router.push(`/shipment/${shipment.id}`)
    },
    updateFilters(filters) {
      this.filters = JSON.parse(JSON.stringify(filters), (key, value) => value === null || value === '' ? undefined : value)
      this.exportEnabled = true
      if (Object.keys(this.filters).length === 0) {
        this.exportEnabled = false
      }
    },
    exportExcel() {
      this.loadingExport = true
      download('export/shipment', null, this.filters).finally(() => {
        this.loadingExport = false
      })
    }
  }
}
</script>
